import { getUser } from "@sourcewhale/shared/src/assets/js/src/general/utils.js";
import { viewerId } from "./usersAndGroups.js";

const dashboardLocalStorageKey = `dashboardSettings-${viewerId}-${getUser().teamId}`;

export const getFromLocalStorage = (key) =>
  JSON.parse(localStorage.getItem(dashboardLocalStorageKey) || "{}")[key];

export const saveToLocalStorage = (key, value) => {
  const updatedSettings = {
    ...JSON.parse(localStorage.getItem(dashboardLocalStorageKey) || "{}"),
    [key]: value,
  };

  localStorage.setItem(
    dashboardLocalStorageKey,
    JSON.stringify(updatedSettings),
  );
};

export const arraysHaveSameStrings = (arr1, arr2) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  return set1.size === set2.size && [...set1].every((item) => set2.has(item));
};

export const getActivityOption = (options, kind) =>
  options.find((option) => option.value === getFromLocalStorage(kind)) ||
  options.find((option) => option.default);

export const getStickyMultiOptions = (kind, options, defaultOptions = null) => {
  const storedOptions = getFromLocalStorage(kind);

  if (!storedOptions) {
    return defaultOptions || options;
  }

  const storedValues = storedOptions.map((opt) => opt.value);
  const validValues = options.map((opt) => opt.value);

  if (storedValues.every((value) => validValues.includes(value))) {
    // For some dropdowns (groups & users), stored options may no longer be
    // valid as groups and users can be added/removed if there are any invalid
    // options, we default to defaultOptions
    return storedOptions;
  }

  return defaultOptions || options;
};

export const returnArrayWithLargestValue = (arrays) => {
  const filteredArrays = arrays.filter((arr) => arr?.length);

  if (filteredArrays.length === 0) {
    return [];
  }
  if (filteredArrays.length === 1) {
    return filteredArrays[0];
  }

  const ret = {};
  filteredArrays.forEach((arr) => {
    ret[Math.max(...arr)] = arr;
  });

  return ret[Math.max(...Object.keys(ret))];
};

export const formatDatum = (datum, type) => {
  if (type === "%") {
    return datum === null ? "-" : `${datum}%`;
  }
  return datum;
};

const innerSort = (a, b, order = -1) => {
  switch (true) {
    case a === null && b === null:
      return 0;
    case a === 0 && b === null:
      return order;
    case b === 0 && a === null:
      return -order;
    default:
      return order === -1 ? b - a : a - b;
  }
};

export const sortData = (x, option, order = -1) =>
  [...x].sort((a, b) => innerSort(a[option], b[option], order));

export const calculateRankingMapping = (data, dataKey) => {
  const rankingMapping = {};
  [...new Set(data.map((item) => item[dataKey]))]
    .sort((a, b) => innerSort(a, b))
    .forEach((value, index) => {
      rankingMapping[value] = index;
    });

  return rankingMapping;
};
